module.exports = __webpack_public_path__ + "static/media/21ECLAC38.9fe7103c.jpg";